import { Component } from '@angular/core';

@Component({
  selector: 'app-quotes',
  template: `
                <div>
                    <router-outlet></router-outlet>
                </div>
             ` ,
})

export class QuotesComponent {

}
